import dayjs from 'dayjs';

/** Monday–Sunday dates (YYYY-MM-DD) for the week that contains `dateIso`. */
export function mealWeekIsos(dateIso) {
	const selected = dayjs(dateIso);
	const weekStart =
		selected.day() === 0 ? selected.subtract(6, 'day') : selected.startOf('week').add(1, 'day');
	return Array.from({ length: 7 }, (_, i) => weekStart.add(i, 'day').format('YYYY-MM-DD'));
}
